import { api } from "../..";

const FinancialDashboardService = async (startDate?: string, endDate?: string) => {
    const response = await api.get('financial/dashboard', {
        params: { startDate, endDate }
    });
    return response;
};

export { FinancialDashboardService };
